import React from "react";
import R14, { Text, View, Image, StyleSheet, Dimensions} from "../core";
import { BILLER_STATUS, PAM_TYPES } from "../constant/app.data.constant";
import Touchable from "../components/TouchableComponent";
import DateUtils from "../utils/DateUtils";

import JsonToCSV from "../utils/JsonToCSV";
import HtmlDecode from "../utils/HtmlDecode";
import PAMGridTableComponent from "../components/PAMGridTableComponent";
import PAMColumnTableComponent from "../components/PAMColumnTableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import HeaderTitleComponent from "../components/HeaderTitleComponent";
import StatusComponent from "../components/StatusComponent";
import { customCommonStyles } from "../assets/css/customCommonStyle";


import attachedFileIcon from"../assets/images/attachedFileIcon.png";
import removeFilterIcon from"../assets/images/NewRemoveFilterIcon.png";


const defaultSec = 60; //60

export default R14.connect(
  class BillersDirectoryScreen extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        pageData: [],
        totalRows: 0,
        page: 1,
        lastSearchedTxt: "",
        pageReRender: 0,
      }
      this.timerInstance = null;
    }

    componentDidMount() {
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      if(isMobileDevice) {
        this.props.app.dm.userSession.setState({ isLoading: true });
        this.getPageData({}, {}, false);
        this.timerInstance = setInterval(async () => {
          const { isSearchOpen } = this.props.app.dm.userSearchDomain.state;
          if(!!isSearchOpen) return false;
          else {
            await this.getPageData({}, {}, false);
            this.setState({pageReRender: this.state.pageReRender + 1})
          }
        }, 1000 * defaultSec);
      }
    }

    componentWillUnmount() {
      if (this.timerInstance) {
        clearInterval(this.timerInstance);
      }
      this.setState({pageData: [], totalRows: 0, page: 1, lastSearchedTxt: "", pageReRender: 0});
      this.props.app.dm.filterDomain.setState({ showPAMResetFilterBtn: false, selectedPamStatus: "" });
    }

    onNavigate = (item) => {
        this.props.app.nav.to("pamMessageRoute", { pamId: item.pamId, pid: item.payerId });
        return false;
    };

    navigateTo = async (path) => {
      this.props.app.nav.to(path);
    };

    
    convertToCSV = async() => {
      let result = this.state.pageData;
      if (result.length){
          result = result.map(item => {
            return {
              "Biller": item.billerName || item.biller.billerName,
              "Status": BILLER_STATUS[item.status],
            }
          })
        const csvContent = JsonToCSV.convertJsonToCSV(result);
        HtmlDecode.downloadUTF8file({
          content: csvContent,
          filename: `Payer Authorization_${DateUtils.formatYYYYMMDDHHMMSS()}.csv`
        })
      }
      return false;
    }

    getPageData = async (
      query = {},
      options = {},
      loaderShown = true
    ) => {
      try {
        if(loaderShown) this.props.app.dm.userSession.setState({ isLoading: true });
        if (!this.props.app) return { pageData: [], totalRows: 0 };
        const {lastSearchedTxt} = this.state;

        const { page = null, rowsPerPage = 10, sortColumnName, sortDirection, search = null } = query;
        const filter = {};
        const { showPAMResetFilterBtn, selectedPamStatus } = this.props.app.dm.filterDomain.state;
        if(showPAMResetFilterBtn && selectedPamStatus) {
          const status = selectedPamStatus === PAM_TYPES.ACTIVE ? 'accepted' : 
                          selectedPamStatus === PAM_TYPES.DECLINED ? 'denied' : 
                          "requested";
          filter.status = {eq: status}
        }
        // if search has value then search by search else search by last search state (to prevent data while setTimeout)
        const searchTxt = search === null ? lastSearchedTxt : search;
        const pageNo = page === null ? this.state.page : page;
        let res = !this.props.app ? {} : await this.props.app.dm.billerDirectoryDomain.getPamMessages(
          {
            page: pageNo,
            resultsPerPage: rowsPerPage,
            search: searchTxt,
            filter,
            ...(sortColumnName ? {sort: [{  field: sortColumnName, order: sortDirection.toUpperCase()  }]} : {})
          }
        );
        this.setState({pageData: res.nodes, totalRows: res.totalCount, page: pageNo, lastSearchedTxt: searchTxt});
        return {
          pageData: res.nodes,
          totalRows: res.totalCount
        };
      } catch (error) {
        this.setState({pageData: [], totalRows: 0});
        return {
          pageData: [],
          totalRows: 0,
          lastSearchedTxt: ''
        };
      } finally {
        this.props.app.dm.userSession.setState({ isLoading: false });
      }
    }

    onClosePAMFilter = () => {
      this.props.app.dm.filterDomain.setState({selectedPamStatus: "", showPAMResetFilterBtn: false});
      this.props.app.dm.userSession.setState({ isLoading: true });
      this.getPageData();
      return false;
    }

    renderPAMSelectedFilterOpt() {
      const { showPAMResetFilterBtn, selectedPamStatus } = this.props.app.dm.filterDomain.state;
      const statusOtp = !!selectedPamStatus && [selectedPamStatus];
      return !!statusOtp && !!statusOtp.length ? (
        <View
          style={[
            commonStyles.flex1,
            commonStyles.flexDirectionRow,
            commonStyles.justifyContentSpaceBetween,
            responsiveTableStyle.filterBySection,
            !!statusOtp && !!statusOtp.length ? responsiveTableStyle.filterBySectionWithFiler : null,
            styles.pamFilterOpt
          ]}>
          <View style={[responsiveTableStyle.filtereHading]}>
            <Text style={[responsiveTableStyle.marB10, commonFontStyles.workSans, commonMetricsStyle.heading6, commonStyles.fontWeight600]}>Filter by: </Text>
          </View>
          <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.flexGrow1, commonStyles.flexWrap, commonStyles.alignItemsCenter]}>
            {statusOtp.map((el, ind) => (
              <StatusComponent
                key={ind}
                label={el}
                isSelected={true}
                circleNotAllowed={true}
                hasClose
                marginBottom={[commonStyles.marB0]}
                onCrossClick={() => this.onClosePAMFilter()}
                wrapperStyle={[styles.statusWrapperStyle]}
              />
            ))}
          </View>
          {(!!statusOtp && !!statusOtp.length) || selectedPamStatus ? (
            <View tooltip={'Remove All Filters'} style={[commonStyles.marginLeftRight16, commonStyles.marginRight8]}>
                <Touchable onPress={() => this.onClosePAMFilter()} hidden={!showPAMResetFilterBtn}>
                  <View>
                    <Image source={removeFilterIcon} style={commonStyles.icon18} />
                  </View>
                </Touchable>
            </View>
          ) : null
          }
        </View>
      ) : null;
    }

    render() {
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      const { pageData, totalRows, page, lastSearchedTxt, pageReRender } = this.state;
      return (
        <View style={[customCommonStyles.childMainContainer]}>
              <HeaderTitleComponent
                title={this.props.r14.navigation.currRoute._config.label}
                convertToCSV={() => this.convertToCSV()}
                getPageData={this.getPageData}
                isSearchIcon={true}
                searchText={lastSearchedTxt}
                isAddMessage={false}
                downloadCsv={true}
                dataSort={false}
              />
              {isMobileDevice && <View style={[responsiveTableStyle.filterBySectionWrapper]}>{ this.renderPAMSelectedFilterOpt()}</View>}
              <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, customCommonStyles.webPAMchildContainer ]}>
                {isMobileDevice ? (
                  pageReRender >= 1 || pageData.length ? <PAMColumnTableComponent
                    onProfileIcon={(item) => this.onNavigate(item)}
                    getPageData={this.getPageData}
                    pageData={pageData}
                    totalRows={totalRows}
                    page={page}
                    rowsPerPage={10}
                    isPAMScreen={true}
                    message = {"No billers found."}
                  /> : null
                ) : (
                <PAMGridTableComponent
                  name={'clients'}
                  labelKeys={[
                    {label: "Biller"},
                    {label: "Status"},
                    {label: "Action", width: 80}
                  ]}
                  labelValues={["biller.billerName", "status", "BlockMenu"]}
                  onProfileIcon={(item) => this.onNavigate(item)}
                  message={"No billers found."}
                  profileIcon={"biller.billerName"}
                  searchable={true}
                  rowControlsRight={null}
                  getPageData={this.getPageData}
                  autoRefresh={defaultSec}
                  rowsPerPage={10}
                  isPAMScreen={true}
                  billers={[]}
                  headerControlsRight={[ 
                    <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
                      <View style={[commonStyles.paddingRight16]} >
                        <Touchable tooltip={'Export to CSV'} onPress={() => this.convertToCSV()}>
                          <Image source={attachedFileIcon} style={commonStyles.icon18} />
                        </Touchable>
                      </View>
                    </View>
                  ]}
                />
              )}
              </View>
        </View>
      );
    }
  }
);
const styles = StyleSheet.create({
  ScrollViewContainer: {
    position: 'relative',
    height:  Dimensions.get("window").height,
    width: "100%",
  },
  pamFilterOpt: {
    paddingLeft: 16,
    paddingRight: 10
  },
  statusWrapperStyle: {
    maxHeight: 26,
    minHeight: 26,
    marginBottom: 5,
  },
});
